module.exports = __webpack_public_path__ + "media/8.a6af93c3.mp3";